document.querySelectorAll('.read-more-btn').forEach( (btn) => {
	btn.addEventListener('click', function () {
		let txtMore = 'Read More'
		txtLess = 'Read Less'
		moreContent = this.parentElement.querySelector('.read-more-content');
		this.classList.toggle('active');
		if (this.classList.contains('active')) {
			this.innerHTML = txtLess;
			moreContent.style.display = 'block';
		} else {
			this.innerHTML = txtMore;
			moreContent.style.display = 'none';
		}
	});
});

/* Mobile: stop whole-page horizontal swipe (overflow from tables/menus/apps) */
(function () {
  var style = document.createElement('style');
  style.setAttribute('data-sibom-overflow', '1');
  style.textContent = [
    '@media screen and (max-width: 749px){',
    'html,body{overflow-x:hidden!important;max-width:100%!important;overscroll-behavior-x:none;}',
    '#PageContainer,.page-container,.site-main,main,.wrapper,.shopify-section{max-width:100%;overflow-x:clip;}',
    '.product__container,.productgrid--outer,.product-main,.product-section,.pdp,.pdp-section,.pdp__shell,.pdp-section-wrapper{max-width:100%!important;min-width:0;overflow-x:clip;}',
    'img,svg,video,iframe,canvas{max-width:100%;}',
    '.site-header,.site-header-wrapper,.site-header-main,.live-search{max-width:100%;overflow-x:clip;}',
    '.mm-nav,#mm-menu,.buddha-menu,[id*="buddha"],[class*="buddha-menu"]{max-width:100vw;overflow-x:hidden;}',
    '.pdp-specs__legacy,.pdp-specs__scroll,.pdp-details__rte,.pdp-features__legacy,table{max-width:100%;}',
    '.pdp-faq__item summary,.pdp-faq__answer{overflow-wrap:anywhere;word-break:break-word;}',
    '}'
  ].join('');
  (document.head || document.documentElement).appendChild(style);
})();

/* Product pages: hide BSS promo / countdown widgets */
(function () {
  if (!document.body.classList.contains('template-product') && !document.body.className.match(/product/)) {
    /* still run if product-quote-priced or product template class present */
  }

  function hidePromoWidgets() {
    if (document.body.className.indexOf('product') === -1 && !document.querySelector('[data-product-details], .product-details, .product__details')) {
      return;
    }
    document.querySelectorAll('[class*="bss"], [id*="bss"], [class*="countdown"], [class*="Countdown"]').forEach(function (el) {
      var text = (el.textContent || '').toLowerCase();
      var className = (el.className && el.className.toString ? el.className.toString() : '').toLowerCase();
      if (
        text.indexOf('deal of the day') !== -1 ||
        text.indexOf('summer sale') !== -1 ||
        text.indexOf('countdown') !== -1 ||
        className.indexOf('countdown') !== -1 ||
        className.indexOf('bss-pl') !== -1 ||
        className.indexOf('timer') !== -1
      ) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  hidePromoWidgets();
  document.addEventListener('DOMContentLoaded', hidePromoWidgets);
  [400, 1200, 2500, 5000].forEach(function (ms) {
    setTimeout(hidePromoWidgets, ms);
  });
})();

/* Quote PDPs: keep Contact for Pricing + hide BSS Deal/countdown widgets */
(function () {
  if (!document.body.classList.contains('product-quote-priced')) return;

  var QUOTE_HTML = '<span class="price__quote-label" data-price-quote>Contact for Pricing</span>';

  function restoreQuotePrice() {
    document.querySelectorAll('[data-product-quote-price] [data-price-container]').forEach(function (el) {
      if (!el.querySelector('[data-price-quote]')) {
        el.innerHTML = QUOTE_HTML;
      }
      el.querySelectorAll('.money').forEach(function (money) {
        money.remove();
      });
    });
  }

  function hideDealWidgets() {
    var nodes = document.querySelectorAll(
      '[class*="bss"], [id*="bss"], [class*="countdown"], [class*="Countdown"]'
    );
    nodes.forEach(function (el) {
      var text = (el.textContent || '').toLowerCase();
      var className = (el.className && el.className.toString
        ? el.className.toString()
        : ''
      ).toLowerCase();
      if (
        text.indexOf('deal of the day') !== -1 ||
        text.indexOf('countdown') !== -1 ||
        className.indexOf('countdown') !== -1
      ) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function run() {
    restoreQuotePrice();
    hideDealWidgets();
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  [300, 800, 1600, 3200].forEach(function (ms) {
    setTimeout(run, ms);
  });

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function () {
      run();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 8000);
  }
})();

/* Hide Summer / Spring Sale nav entries (Buddha Mega Menu + native) */
(function () {
  var style = document.createElement('style');
  style.setAttribute('data-sibom-hide-sale', '1');
  style.textContent = [
    '.navmenu-id-spring-sale,',
    '.navmenu-id-summer-sale,',
    'li.buddha-menu-item:has(> a[href*="/collections/spring-sale"]),',
    'li.buddha-menu-item:has(> a[aria-label="Summer Sale"]),',
    'li.buddha-menu-item:has(> a[aria-label="Spring Sale"]),',
    '.site-header a[href*="/collections/spring-sale"],',
    '.header a[href*="/collections/spring-sale"],',
    '#shopify-section-header a[href*="/collections/spring-sale"],',
    '.mm-nav a[href*="/collections/spring-sale"]',
    '{display:none!important;}'
  ].join('');
  document.documentElement.appendChild(style);

  function hideSaleNav() {
    var nodes = document.querySelectorAll(
      'a[href*="/collections/spring-sale"], a[aria-label="Summer Sale"], a[aria-label="Spring Sale"]'
    );
    nodes.forEach(function (a) {
      var inHeader =
        a.closest(
          'header, .site-header, .header, #shopify-section-header, .mm-nav, .buddha-menu, [id*="buddha"], [class*="buddha"], .navmenu, #MobileNav, .mobile-nav'
        ) != null;
      if (!inHeader) return;
      var item = a.closest('li, .navmenu-item, .buddha-menu-item') || a;
      item.style.setProperty('display', 'none', 'important');
      item.setAttribute('aria-hidden', 'true');
    });

    document.querySelectorAll('.mm-title, .navmenu-link-title, .navmenu-link').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t !== 'summer sale' && t !== 'spring sale') return;
      var item = el.closest('li, .navmenu-item, .buddha-menu-item') || el;
      item.style.setProperty('display', 'none', 'important');
      item.setAttribute('aria-hidden', 'true');
    });
  }

  hideSaleNav();
  document.addEventListener('DOMContentLoaded', hideSaleNav);
  [300, 800, 1600, 3200, 6000].forEach(function (ms) {
    setTimeout(hideSaleNav, ms);
  });
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(hideSaleNav);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 10000);
  }
})();

/* Ensure News appears in Buddha Mega Menu + simplify News submenu */
(function () {
  function newsVisibleInTopNav() {
    var found = false;
    document.querySelectorAll('li.buddha-menu-item').forEach(function (li) {
      if (li.parentElement && li.parentElement.closest('li.buddha-menu-item')) return;
      var a = li.querySelector(':scope > a');
      if (!a) return;
      var title = ((a.querySelector('.mm-title') || a).textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var href = a.getAttribute('href') || a.getAttribute('data-href') || '';
      if (title !== 'news' && href.indexOf('/blogs/news') === -1) return;
      if (getComputedStyle(li).display === 'none' || li.getAttribute('aria-hidden') === 'true') return;
      found = true;
    });
    /* Also native Empire nav */
    document.querySelectorAll('.site-navigation > .navmenu > .navmenu-item > a, .navmenu--main > .navmenu-item > a').forEach(function (a) {
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var href = a.getAttribute('href') || '';
      if (t === 'news' || href.indexOf('/blogs/news') !== -1) found = true;
    });
    return found;
  }

  function injectNewsItem(list) {
    if (!list) return;
    if (list.querySelector('[data-sibom-news-link]')) return;
    var li = document.createElement('li');
    li.className = 'buddha-menu-item';
    li.setAttribute('role', 'none');
    li.setAttribute('data-sibom-news-link', '1');
    li.innerHTML =
      '<a data-href="/blogs/news" href="/blogs/news" aria-label="News" role="menuitem">' +
      '<span class="mm-title">News</span></a>';
    /* Prefer before Contact / About / Affiliate */
    var kids = Array.prototype.slice.call(list.children);
    var insertBefore = null;
    kids.forEach(function (child) {
      if (insertBefore) return;
      var t = (child.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (
        t.indexOf('contact') === 0 ||
        t.indexOf('about') === 0 ||
        t.indexOf('affiliate') === 0
      ) {
        insertBefore = child;
      }
    });
    if (insertBefore) list.insertBefore(li, insertBefore);
    else list.appendChild(li);
  }

  function ensureNewsNav() {
    /* Hide Product Blog / duplicate News under a News parent only */
    document.querySelectorAll('li.buddha-menu-item, li.navmenu-item').forEach(function (li) {
      var topLink = li.querySelector(':scope > a');
      if (!topLink) return;
      var title = ((topLink.querySelector('.mm-title') || topLink).textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      var href = topLink.getAttribute('href') || topLink.getAttribute('data-href') || '';
      var isNewsParent = title === 'news' || href.indexOf('/blogs/news') !== -1;
      if (!isNewsParent) return;

      li.querySelectorAll(':scope ul li a[href*="/blogs/"], :scope .mm-submenu a[href*="/blogs/"]').forEach(function (a) {
        var item = a.closest('li') || a;
        item.style.setProperty('display', 'none', 'important');
      });
    });

    if (newsVisibleInTopNav()) return;

    /* Inject into common Buddha / theme menu lists */
    var lists = document.querySelectorAll(
      '.horizontal-mega-menu, .vertical-mega-menu, .mm-nav > ul, ul.mm-menu, #mm-menu > ul, .site-navigation > .navmenu, .navmenu--main'
    );
    lists.forEach(function (list) {
      injectNewsItem(list);
    });
  }

  ensureNewsNav();
  document.addEventListener('DOMContentLoaded', ensureNewsNav);
  [400, 1200, 2500, 5000, 8000].forEach(function (ms) {
    setTimeout(ensureNewsNav, ms);
  });
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function () {
      ensureNewsNav();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 12000);
  }
})();

/* Hide menu links to collections with no published products (Buddha + header) */
(function () {
  function readEmptyHandles() {
    var el = document.getElementById('sibom-empty-collections');
    if (!el) return ['excavator-attachments'];
    try {
      var list = JSON.parse(el.textContent || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return ['excavator-attachments'];
    }
  }

  function hideEmptyCollectionNav() {
    var handles = readEmptyHandles();
    if (!handles.length) return;

    var headerSel =
      'header, .site-header, .header, #shopify-section-header, .mm-nav, .buddha-menu, [id*="buddha"], [class*="buddha"], .navmenu, #MobileNav, .mobile-nav, .site-navigation';

    handles.forEach(function (handle) {
      var needle = '/collections/' + handle;
      document.querySelectorAll('a[href*="' + needle + '"]').forEach(function (a) {
        if (!a.closest(headerSel)) return;
        var item = a.closest('li, .navmenu-item, .buddha-menu-item, .mm-listitem') || a;
        item.style.setProperty('display', 'none', 'important');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('data-sibom-empty-collection', handle);
      });
    });

    document.querySelectorAll('.mm-title, .navmenu-link, .navmenu-link-title').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t !== 'excavator attachments') return;
      var a = el.closest('a') || el;
      if (!a.closest(headerSel)) return;
      var item = a.closest('li, .buddha-menu-item, .navmenu-item, .mm-listitem') || a;
      item.style.setProperty('display', 'none', 'important');
      item.setAttribute('aria-hidden', 'true');
    });
  }

  hideEmptyCollectionNav();
  document.addEventListener('DOMContentLoaded', hideEmptyCollectionNav);
  [300, 800, 1600, 3200, 6000, 10000].forEach(function (ms) {
    setTimeout(hideEmptyCollectionNav, ms);
  });
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(hideEmptyCollectionNav);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 15000);
  }
})();

/* Hide Ecomsend popups/overlays for a cleaner DTC storefront */
(function () {
  function hideEcomsend() {
    document.querySelectorAll('.shopify-block, .shopify-app-block, [id*="ecomsend"], [class*="ecomsend"]').forEach(function (el) {
      var html = el.outerHTML || '';
      var id = el.id || '';
      var cls = (el.className && el.className.toString) ? el.className.toString() : '';
      if (
        html.toLowerCase().indexOf('ecomsend') !== -1 ||
        id.toLowerCase().indexOf('ecomsend') !== -1 ||
        cls.toLowerCase().indexOf('ecomsend') !== -1
      ) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      }
    });
    document.querySelectorAll('iframe[src*="ecomsend"]').forEach(function (frame) {
      frame.style.setProperty('display', 'none', 'important');
      var parent = frame.closest('.shopify-block, .shopify-app-block, [class*="popup"]');
      if (parent) parent.style.setProperty('display', 'none', 'important');
    });
  }

  hideEcomsend();
  document.addEventListener('DOMContentLoaded', hideEcomsend);
  [500, 1500, 3000, 6000].forEach(function (ms) {
    setTimeout(hideEcomsend, ms);
  });
})();
